import React, { useEffect, useRef, useState } from 'react';
import {
  // BrowserRouter as Router,
  useHistory,
  Link,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { DataGrid } from '@material-ui/data-grid';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { firestore } from '../firebase/firebase';
import getDateString from '../utilities/getDateString';
import { statusCodes } from '../utilities/constants';

const personnummer = require('personnummer.js');

const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
      cursor: "pointer",
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: "100%",
    marginBottom: 30,
  },
  searchInput: {
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 20,
  },
  ul: {
    marginBottom: 50,
    '& li': {
      marginBottom: 10,
    },
  },
}));

function Members() {
  const rowsRef = useRef();
  const columnsRef = useRef();
  const [users, setUsers] = useState([]);
  const [storeGroups, setStoregroups] = useState([]);
  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    customerId: "",
    memberId: "",
    personalId: "",
    lmaNumber: "",
    birthDate: "",
    storeGroup: "",
    submissionStatus: "",
    district: "",
    membershipActive: "",
  });

  const [sortModel, setSortModel] = useState([{
    field: 'updatesFromCustomer',
    sort: 'asc'
  }]);
  let history = useHistory();

  useEffect(() => {
    const init = async () => {
      getStoreGroups();
    };
    init();
  }, []);

  const handleFilterChange = event => {
    let value = event.target.value;
    // if (event.target.name === 'firstName' || event.target.name === 'lastName') {
    //   const words = value?.split(" ").map((word, index) => {
    //     if (!word) { return ""; }
    //     return word[0]?.toUpperCase() + word.substr(1);
    //   });
    //   value = words?.join(" ");
    // }
    setFilter({
      ...filter,
      [event.target.name]: value,
    });
  };

  const resetForm = () => {
    const keys = Object.keys(filter);
    let values = {};
    keys.forEach(key => values[key] = "");
    setFilter(values);
    setUsers([]);
  };

  const formIsEmpty = () => {
    let nbrOfFilters = 0;
    Object.keys(filter).forEach(key => {
      if (filter[key] !== "") {
        nbrOfFilters++;
      }
    });
    if (nbrOfFilters === 0) {
      return true;
    }
    return false;
  };

  const handleSearchSubmit = async (event) => {

    event.preventDefault();

    const users = [];
    let query = firestore.collection('users');
    if (filter.customerId) {
      query = query.where('customerId', '==', parseInt(filter.customerId));
    }
    if (filter.memberId) {
      query = query.where('memberId', '==', parseInt(filter.memberId));
    }
    if (filter.firstName) {
      query = query.where('firstName', '==', filter.firstName);
    }
    if (filter.lastName) {
      query = query.where('lastName', '==', filter.lastName);
    }
    if (filter.personalId) {
      if (personnummer.validate(filter.personalId) === false) {
        return;
      }
      const normalisedPersonalId = personnummer.normalise(filter.personalId);
      query = query.where('personalId', '==', normalisedPersonalId);
    }
    if (filter.lmaNumber) {
      query = query.where('lmaNumber', '==', filter.lmaNumber);
    }
    if (filter.storeGroup) {
      if (!filter.submissionStatus) {
        query = query.where('storeGroupRef', '==', filter.storeGroup.ref);
      } else {
        query = query.where('submission.storeGroupRef', '==', filter.storeGroup.ref);
      }
    }
    if (filter.submissionStatus) {
      query = query.where('submission.statusCode.code', '==', filter.submissionStatus);
    }
    if (filter.district) {
      if (!filter.submissionStatus) {
        query = query.where('district', '==', filter.district);
      } else {
        query = query.where('submission.district', '==', filter.district);
      }
    }
    if (typeof filter.membershipActive === 'boolean') {
      query = query.where('membershipActive', '==', filter.membershipActive);
    }
    try {
      const querySnapshot = await query.get();
      querySnapshot.forEach(userSnapshot => {
        users.push({
          uid: userSnapshot.id,
          ...userSnapshot.data(),
        });
      });
    } catch (error) {
      console.error("Could not query users. ", error);
    }

    const maxResult = 4000;
    if (users.length === 0) {
      alert("Tomt sökresultat");
    }
    else if (users.length > maxResult) {
      alert("Din sökning resulterade i " + users.length + " kontakter. Försök begränsa din sökning.");
      setUsers([]);
    }

    if (users.length <= maxResult) {
      setUsers(users);
    }

  };

  const handleRowClick = (param) => {
    const uid = param.row.id;
    history.push("/kunder/" + uid);
  };

  const getStoreGroups = async () => {
    try {
      const storeGroupsSnapshot = await firestore
        .collection('storeGroups')
        .get();
      const groups = [];
      storeGroupsSnapshot.forEach(storeGroup => {
        const data = storeGroup.data();
        data.districts = data.districts.sort();
        groups.push({
          ref: storeGroup.ref,
          ...data,
        });
      });
      setStoregroups(groups);
    } catch (error) {
      console.error("Could not fetch store groups. ", error);
    }
  }

  const classes = useStyles();

  const renderCell = params => (
    <div style={{ width: "100%", backgroundColor: 'blue' }}>
      <Link to={`/kunder/${params.row.id}`}>{params.value}</Link>
    </div>
  );

  columnsRef.current = [
    {
      field: "customerId",
      headerName: "Kundnummer",
      width: 150
      // renderCell: renderCell
    },
    {
      field: "memberId",
      headerName: "Medlemsnummer",
      width: 150
    },
    {
      field: "firstName",
      headerName: "Förnamn",
      width: 150,
    },
    {
      field: "lastName",
      headerName: "Efternamn",
      width: 200
    },
    {
      field: "updatesFromCustomer",
      headerName: "Ansökan uppdaterad av kund",
      width: 280
    },
    {
      field: "membershipActive",
      headerName: "Medlemskap",
      width: 160
    },
    {
      field: "membershipExpirationDate",
      headerName: "Sista medlemsdag",
      width: 160
    },
  ];
  rowsRef.current = users.map((user, index) => (
    {
      id: user.uid,
      customerId: user.customerId,
      memberId: user.memberId,
      firstName: user.firstName,
      lastName: user.lastName,
      membershipActive: user.membershipActive ? "Medlem" : "Ej medlem",
      membershipExpirationDate:
        user.membershipActive &&
          typeof user.membershipExpirationTimestamp !== "undefined" &&
          user.membershipExpirationTimestamp
          ? getDateString(
            user.membershipExpirationTimestamp.toDate(),
            "short"
          )
          : "",
      updatesFromCustomer:
        (!user.submission || typeof user.submission.customerUpdateTimestamp === "undefined") ? ""
          : getDateString(
            user.submission.customerUpdateTimestamp.toDate(),
            "short"
          ),
    }
  ));

  const handleSortChange = (model) => {
    let startingModel = JSON.stringify(sortModel);
    let selectedModel = JSON.stringify(model.sortModel);

    if (selectedModel !== startingModel) {
      setSortModel(model.sortModel);
    }
  };

  return (
    <div style={{ textAlign: "left" }}>

      <Grid container spacing={2} justify={'space-between'}>
        <Grid item xs={6}>
          <Typography
            component="h1"
            variant="h5"
            color="primary"
          >
            Hitta kunder
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right' }}>

          <Button
            variant="outlined"
            color="primary"
            style={{ marginBottom: 20 }}
            onClick={() => history.push("/kunder/ny")}
            startIcon={<AddIcon />}
          >
            Lägg till kund
          </Button>
        </Grid>
      </Grid>

      <form
        onSubmit={handleSearchSubmit}
        className={classes.searchForm}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.customerId}
              onChange={handleFilterChange}
              id="input-customerid"
              variant="outlined"
              label="Kundnummer"
              name="customerId"
              className={classes.searchInput}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.memberId}
              onChange={handleFilterChange}
              id="input-memberid"
              variant="outlined"
              label="Medlemsnummer"
              name="memberId"
              className={classes.searchInput}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.firstName}
              onChange={handleFilterChange}
              id="input-firstname"
              variant="outlined"
              label="Förnamn"
              name="firstName"
              className={classes.searchInput}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.lastName}
              onChange={handleFilterChange}
              id="input-lastname"
              variant="outlined"
              label="Efternamn"
              name="lastName"
              className={classes.searchInput}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.personalId}
              onChange={handleFilterChange}
              id="input-personalid"
              variant="outlined"
              label="Personnummer"
              name="personalId"
              className={classes.searchInput}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.lmaNumber}
              onChange={handleFilterChange}
              id="input-lmanumber"
              variant="outlined"
              label="LMA-nummer åtta siffror"
              name="lmaNumber"
              className={classes.searchInput}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              value={filter.birthDate}
              onChange={handleFilterChange}
              id="input-birthdate"
              variant="outlined"
              label="Födelsedatum ÅÅMMDD"
              name="birthDate"
              className={classes.searchInput}
            />
          </Grid>
        </Grid>

        <div style={{ marginTop: 20 }}>

          <FormControl variant="filled" className={classes.formControl}>
            <InputLabel id="storegroupSelectLabel">Butiksgrupp</InputLabel>
            <Select
              labelId="storegroupSelectLabel"
              id="storegroupSelect"
              name="storeGroup"
              value={filter.storeGroup}
              onChange={handleFilterChange}
              label="Butiksgrupp"
            >
              {storeGroups.map((group, index) => {
                return (
                  <MenuItem value={group} key={index}>
                    {group?.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <FormControl variant="filled" className={classes.formControl}>
            <InputLabel id="submissionSelectLabel">
              Ansökan
            </InputLabel>
            <Select
              labelId="submissionSelectLabel"
              id="submissionSelect"
              name="submissionStatus"
              value={filter.submissionStatus}
              onChange={handleFilterChange}
              label={"Ansökan"}
            >
              {Object.entries(statusCodes).map(statusCode => (
                <MenuItem value={statusCode[1].code} key={statusCode[1].code}>
                  {statusCode[1].label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="filled" className={classes.formControl}>
            <InputLabel id="districtSelectLabel">Stadsdel</InputLabel>
            <Select
              labelId="districtSelectLabel"
              id="districtSelect"
              name="district"
              value={filter.district}
              onChange={handleFilterChange}
              label="Stadsdel"
              disabled={!filter.storeGroup}
            >
              {filter.storeGroup?.districts?.map((district, index) => {
                return (
                  <MenuItem value={district} key={index}>
                    {district}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <FormControl variant="filled" className={classes.formControl}>
            <InputLabel id="memberActiveSelectLabel">
              Medlemskap
            </InputLabel>
            <Select
              labelId="memberActiveSelectLabel"
              id="memberActiveSelect"
              name="membershipActive"
              value={filter.membershipActive}
              onChange={handleFilterChange}
              label="Medlemskap"
            >
              <MenuItem value={true} key={1}>
                Aktivt
              </MenuItem>
              <MenuItem value={false} key={2}>
                Ej aktivt
              </MenuItem>
            </Select>
          </FormControl>
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSearchSubmit}
          startIcon={<SearchIcon />}
          disabled={formIsEmpty()}
          type="submit"
        >
          Sök
        </Button>

        <Button
          variant="outlined"
          color="primary"
          style={{ marginLeft: 8 }}
          onClick={resetForm}
          startIcon={<ClearIcon />}
        >
          Rensa formulär
        </Button>
      </form>

      <Paper className={classes.paper}>
        <div
          style={{ height: 400, width: "100%" }}
          className={classes.root}
        >
          <DataGrid
            sortModel={sortModel}
            onSortModelChange={handleSortChange}
            columns={columnsRef.current}
            rows={rowsRef.current}
            pageSize={10}
            onRowClick={handleRowClick}
          />
        </div>
      </Paper>
    </div>
  );
}

export default Members;
